<template>
  <article id="LOADING" class="container-fixed">
    <transition name="fade" mode="out-in" appear>
      <VSpinner class="offset-top-2" />
    </transition>
  </article>
</template>

<script>
import VSpinner from '@/components/Spinner';

export default {
  name: 'Loading',

  components: {
    VSpinner,
  },
};
</script>
